var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2.50001H15.8333V1.66668C15.8333 1.20834 15.4583 0.833344 15 0.833344C14.5417 0.833344 14.1667 1.20834 14.1667 1.66668V2.50001H5.83333V1.66668C5.83333 1.20834 5.45833 0.833344 5 0.833344C4.54166 0.833344 4.16666 1.20834 4.16666 1.66668V2.50001H3.33333C2.41666 2.50001 1.66666 3.25001 1.66666 4.16668V17.5C1.66666 18.4167 2.41666 19.1667 3.33333 19.1667H16.6667C17.5833 19.1667 18.3333 18.4167 18.3333 17.5V4.16668C18.3333 3.25001 17.5833 2.50001 16.6667 2.50001ZM15.8333 17.5H4.16666C3.70833 17.5 3.33333 17.125 3.33333 16.6667V6.66668H16.6667V16.6667C16.6667 17.125 16.2917 17.5 15.8333 17.5Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.00bd5d446ebaf1d5fb1c38352c00b456.svg";
export { ForwardRef as ReactComponent };